export const EXPRESSION_DATA = [
  {
    nodeId: '1',
    label: 'SmartSolve',
    description: '',
    value: '',
    usage: '',
    childNodes: [
      {
        nodeId: '2',
        label: 'Current User',
        usage: '',
        value: '',
        description: '',
        childNodes: [
          {
            nodeId: '3',
            label: 'Actor Code',
            usage: 'ss.actorCode()',
            description: 'Returns the current users actor code.',
            value: 'ss.actorCode()',
            childNodes: [],
          },
          {
            nodeId: '4',
            label: 'Current Culture',
            usage: 'ss.culture()',
            description: 'Returns the current users culture.',
            value: 'ss.culture()',
            childNodes: [],
          },
          {
            nodeId: '5',
            label: 'Department/Org Unit',
            usage: 'ss.orgUnitCode()',
            description: 'Returns the current users organization unit code.',
            value: 'ss.orgUnitCode()',
            childNodes: [],
          },
          {
            nodeId: '6',
            label: 'Has Right',
            usage: "ss.hasRight('Customer Exception View')",
            description: 'Checks if the user has the specified right in the system.',
            value: "ss.hasRight('[RIGHT_NAME]')",
            childNodes: [],
          },
          {
            nodeId: '7',
            label: 'Has Role',
            usage: "ss.hasRole('ADMINISTRATOR')",
            description: 'Checks if the user has the specified role in the system.',
            value: "ss.hasRole('[ROLE_NAME]')",
            childNodes: [],
          },
          {
            nodeId: '8',
            label: 'Logged On Domain',
            usage: 'ss.loggedOnDomain()',
            description: "Returns the current user's logged on domain.",
            value: 'ss.loggedOnDomain()',
            childNodes: [],
          },
          {
            nodeId: '9',
            label: 'Logged On Organization',
            usage: 'ss.loggedOnOrgCode()',
            description: 'Returns the current users organization.',
            value: 'ss.loggedOnOrgCode()',
            childNodes: [],
          },
          {
            nodeId: '10',
            label: 'Login',
            usage: 'ss.userCode()',
            description: 'Returns the current users user code.',
            value: 'ss.userCode()',
            childNodes: [],
          },
          {
            nodeId: '11',
            label: 'Org Unit 1 Id',
            usage: 'ss.orgUnit1Id()',
            description: 'Returns the current users Org Unit 1 id.',
            value: 'ss.orgUnit1Id()',
            childNodes: [],
          },
          {
            nodeId: '12',
            label: 'Org Unit 1 Code',
            usage: 'ss.orgUnit1Code()',
            description: 'Returns the current users Org Unit 1 code.',
            value: 'ss.orgUnit1Code()',
            childNodes: [],
          },
          {
            nodeId: '13',
            label: 'Org Unit 1 Name',
            usage: 'ss.orgUnit1Name()',
            description: 'Returns the current users Org Unit 1 name.',
            value: 'ss.orgUnit1Name()',
            childNodes: [],
          },
          {
            nodeId: '14',
            label: 'Org Unit 2 Id',
            usage: 'ss.orgUnit2Id()',
            description: 'Returns the current users Org Unit 2 id.',
            value: 'ss.orgUnit2Id()',
            childNodes: [],
          },
          {
            nodeId: '15',
            label: 'Org Unit 2 Code',
            usage: 'ss.orgUnit2Code()',
            description: 'Returns the current users Org Unit 2 code.',
            value: 'ss.orgUnit2Code()',
            childNodes: [],
          },
          {
            nodeId: '16',
            label: 'Org Unit 2 Name',
            usage: 'ss.orgUnit2Name()',
            description: 'Returns the current users Org Unit 2 name.',
            value: 'ss.orgUnit2Name()',
            childNodes: [],
          },
          {
            nodeId: '17',
            label: 'Org Unit 3 Id',
            usage: 'ss.orgUnit3Id()',
            description: 'Returns the current users Org Unit 3 id.',
            value: 'ss.orgUnit3Id()',
            childNodes: [],
          },
          {
            nodeId: '18',
            label: 'Org Unit 3 Code',
            usage: 'ss.orgUnit3Code()',
            description: 'Returns the current users Org Unit 3 code.',
            value: 'ss.orgUnit3Code()',
            childNodes: [],
          },
          {
            nodeId: '19',
            label: 'Org Unit 3 Name',
            usage: 'ss.orgUnit3Name()',
            description: 'Returns the current users Org Unit 3 name',
            value: 'ss.orgUnit3Name()',
            childNodes: [],
          },
          {
            nodeId: '20',
            label: 'Role Code',
            usage: 'ss.roleCode()',
            description: 'Returns the current users role code.',
            value: 'ss.roleCode()',
            childNodes: [],
          },
          {
            nodeId: '21',
            label: 'Role Name',
            usage: 'ss.roleName()',
            description: 'Returns the current users role name.',
            value: 'ss.roleName()',
            childNodes: [],
          },
          {
            nodeId: '22',
            label: 'Site Code',
            usage: 'ss.siteCode()',
            description: 'Returns the current users site code.',
            value: 'ss.siteCode()',
            childNodes: [],
          },
          {
            nodeId: '23',
            label: 'Site Id',
            usage: 'ss.siteId()',
            description: 'Returns the current users sie id.',
            value: 'ss.siteId()',
            childNodes: [],
          },
          {
            nodeId: '24',
            label: 'Site Name',
            usage: 'ss.siteName()',
            description: 'Returns the current users site name.',
            value: 'ss.siteName()',
            childNodes: [],
          },
          {
            nodeId: '25',
            label: 'Title',
            usage: 'ss.actorTitle()',
            description: 'Returns current users title.',
            value: 'ss.actorTitle()',
            childNodes: [],
          },
        ],
      },
      {
        nodeId: '26',
        label: 'Hyperlinks',
        usage: '',
        description: '',
        childNodes: [
          {
            nodeId: '27',
            label: 'Launch Report',
            usage:
              "ss.stringFormat('../SmartReport.aspx?RptName={0}&AppName={1}','LogReport','SmartSolve')",
            value:
              "ss.stringFormat('../SmartReport.aspx?RptName={0}&[ParamName]={1}','[ReportName]','[ParamValue]')",
            description: 'Builds the document view with reference url.',
            childNodes: [],
          },
          {
            nodeId: '28',
            label: 'Show Document With Reference',
            usage:
              "ss.stringFormat('../SmartDocumentView.aspx?DOCNO={0}&DOCREV={1}&LATESTREV=true','DOC-0001','1')",
            value:
              "ss.stringFormat('../SmartReport.aspx?RptName={0}&[ParamName]={1}','[ReportName]','[ParamValue]')",
            description: 'Builds the report url.',
            childNodes: [],
          },
          {
            nodeId: '29',
            label: 'Show Document Without Reference',
            usage:
              "ss.stringFormat('../SmartDocumentView.aspx?DOCNO={0}&DOCREV={1}&LATESTREV=true&SuppressXRef=true','DOC-0001','1')",
            value:
              "ss.stringFormat('../SmartDocumentView.aspx?DOCNO={0}&DOCREV={1}&LATESTREV=true&SuppressXRef=true',[DocumentNumber],[Revision])",
            description: 'Builds the document view without reference url.',
            childNodes: [],
          },
          {
            nodeId: '30',
            label: 'Show Workflow Task',
            usage:
              "ss.stringFormat('../QEI_TASK_REDIRECT.aspx?IssueId={0}&TaskName=ssRiskAssessment','ISS-0001')",
            value:
              "ss.stringFormat('../QEI_TASK_REDIRECT.aspx?IssueId={0}&TaskName=[value]',[TaskId])",
            description: 'Builds the workflow task url.',
            childNodes: [],
          },
        ],
      },
    ],
  },
  {
    nodeId: '31',
    label: 'Operators',
    usage: '',
    value: '',
    description: '',
    childNodes: [
      {
        nodeId: '32',
        label: 'And',
        usage: "'Left' && 'right'",
        value: '&&',
        description: 'Performs a logical conjunction.',
        childNodes: [],
      },
      {
        nodeId: '33',
        label: 'Equals',
        usage: "'Left' == 'Left'",
        value: '==',
        description: 'Equal to.',
        childNodes: [],
      },
      {
        nodeId: '34',
        label: 'Greater Than Or Equal To',
        usage: '2 >= 1 ',
        value: '>=',
        description: 'Greater than or equal to.',
        childNodes: [],
      },
      {
        nodeId: '35',
        label: 'Greater Than',
        usage: '2 > 1',
        value: '>',
        description: 'Greater than.',
        childNodes: [],
      },
      {
        nodeId: '36',
        label: 'Less Than',
        usage: '1 < 2',
        value: '<',
        description: 'Less than.',
        childNodes: [],
      },
      {
        nodeId: '37',
        label: 'Less Than Or Equal To',
        usage: '1 <= 2',
        value: '<=',
        description: 'Less than or equal to.',
        childNodes: [],
      },
      {
        nodeId: '38',
        label: 'Not Equals',
        usage: "'Left' != 'Right'",
        value: '!=',
        description: 'Not equal to.',
        childNodes: [],
      },
      {
        nodeId: '39',
        label: 'Not',
        usage: '!({|is complaint|v_complaint-v_ss_case_part_lot.prt_is_complaint|})',
        value: '!([expression])',
        description: 'Performs logical negation.',
        childNodes: [],
      },
      {
        nodeId: '40',
        label: 'Or',
        usage: "'Left' || 'right'",
        value: '||',
        description: 'Used to perform a logical disjunction.',
        childNodes: [],
      },
      {
        nodeId: '41',
        label: 'Math',
        usage: '',
        value: '',
        description: '',
        childNodes: [
          {
            nodeId: '42',
            label: 'Add',
            usage:
              '{|confirm defect qty|v_complaint-v_ss_case_part_lot.prt_confirm_deffect_qty|} + {|expected return qty|v_complaint-v_ss_case_part_lot.prt_expected_return_qty|}',
            value: '+',
            description: 'Adds two numbers.',
            childNodes: [],
          },
          {
            nodeId: '43',
            label: 'Divide',
            usage: '{|complaint qty|v_complaint-v_ss_case_part_lot.prt_complaint_qty|} / 2',
            value: '/',
            description: 'Divide two numbers and returns only the remainder.',
            childNodes: [],
          },
          {
            nodeId: '44',
            label: 'Multiply',
            usage:
              '{|confirm defect qty|v_complaint-v_ss_case_part_lot.prt_confirm_deffect_qty|} * 2',
            value: '*',
            description: 'Multiplies two numbers.',
            childNodes: [],
          },
          {
            nodeId: '45',
            label: 'Remainder',
            usage: '{|complaint qty|v_complaint-v_ss_case_part_lot.prt_complaint_qty|} % 50',
            value: '%',
            description: 'Remainder of two numbers.',
            childNodes: [],
          },
          {
            nodeId: '46',
            label: 'Subract',
            usage:
              '{|confirm defect qty|v_complaint-v_ss_case_part_lot.prt_confirm_deffect_qty|} - {|expected return qty|v_complaint-v_ss_case_part_lot.prt_expected_return_qty|}',
            value: '-',
            description: 'Yields the difference between two numbers.',
            childNodes: [],
          },
        ],
      },
    ],
  },
  {
    nodeId: '47',
    label: 'Basic Functions',
    usage: '',
    value: '',
    description: '',
    childNodes: [
      {
        nodeId: '48',
        label: 'Check Expression',
        usage:
          'ss.checkExpression("^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$",{|Email Address|v_complaint.email_address|})',
        value: 'ss.checkExpression("[EXPRESSION]",[VALUE_TO_CHECK])',
        description: 'Checks if value matches expression. Returns true or false.',
        childNodes: [],
      },
      {
        nodeId: '49',
        label: 'Container Workflow Key',
        usage: 'ss.containerWorkflowKey()',
        value: 'ss.containerWorkflowKey()',
        description: 'Returns the container workflow key.',
        childNodes: [],
      },
      {
        nodeId: '50',
        label: 'Contains',
        usage: "ss.contains({|description|v_complaint.complaint_closure_comment|}, 'closed')",
        value: "ss.contains([DATAMEMBER_COLUMN or 'text'], [DATAMEMBER_COLUMN or 'text'])",
        description:
          'Returns true if the first argument string contains the second argument string, otherwise returns false.',
        childNodes: [],
      },
      {
        nodeId: '51',
        label: 'Current Date Time',
        usage: 'ss.now()',
        value: 'ss.now()',
        description:
          'Returns a date value containing the current date and time according to your system.',
        childNodes: [],
      },
      {
        nodeId: '52',
        label: 'Current Date',
        usage: 'ss.today()',
        value: 'ss.today()',
        description:
          'Returns or sets a date value containing the current date according to your system.',
        childNodes: [],
      },
      {
        nodeId: '53',
        label: 'Current Record Id',
        usage: 'ss.currentRecordId()',
        value: 'ss.currentRecordId()',
        description: 'Returns the current record number.',
        childNodes: [],
      },
      {
        nodeId: '54',
        label: 'Date Add',
        usage: "ss.dateAdd('d', 15, {|created date|v_complaint.created_date|})",
        value: "ss.dateAdd('[DATEPART]',[NUMBER],'[DATE]')",
        description:
          'Returns a date value containing a date and time value to which a specified time interval has been added.',
        childNodes: [],
      },
      {
        nodeId: '55',
        label: 'Date Add Business Days',
        usage: 'ss.dateAddBusinessDays(15, {|created date|v_complaint.created_date|})',
        value: "ss.dateAddBusinessDays([NUMBER],'[DATE]', '[SiteCode]')",
        description:
          'Returns a date value containing a date and time value to which a specified time interval (in Business Days) has been added with optional Site Code.',
        childNodes: [],
      },
      {
        nodeId: '56',
        label: 'Date Diff',
        usage:
          "ss.dateDiff('d', {|created date|v_complaint.created_date|}, {|closed date|v_complaint.grc_closed_date|}",
        value: "ss.dateDiff('[DATEPART]','[STARTDATE]','[ENDDATE]')",
        description:
          'Returns a long value specifying the number of time intervals between two date values.',
        childNodes: [],
      },
      {
        nodeId: '57',
        label: 'Ends With',
        usage: "ss.endsWith({|description|v_complaint.complaint_closure_comment|}, 'is closed.')",
        value: "ss.endsWith([DATAMEMBER_COLUMN or 'text'], [DATAMEMBER_COLUMN or 'text'])",
        description:
          'Returns true if the first argument string ends with the second argument string, otherwise returns false.',
        childNodes: [],
      },
      {
        nodeId: '58',
        label: 'Format String',
        usage:
          "ss.stringFormat('The case part record number is {0}', {|case part record id|v_complaint.case_part_record_id|})",
        value:
          "ss.stringFormat('test {0} and test {1}', [DATAMEMBER_COLUMN or 'text'], [DATAMEMBER_COLUMN or 'text'])",
        description:
          'Returns a string formatted according to instructions contained in a format string expression.',
        childNodes: [],
      },
      {
        nodeId: '59',
        label: 'Get Next Number',
        usage: "ss.getNumberingScheme('Numbering Scheme Code')",
        value: "ss.getNumberingScheme('numberingSchemeCode')",
        description: 'Returns the next available record number based on a numbering scheme.',
        childNodes: [],
      },
      {
        nodeId: '60',
        label: 'Get QueryString Param',
        usage: "ss.getQueryStringParam('ItmId',[WINDOW - OPTIONAL])",
        value: "ss.getQueryStringParam('[PARAM_NAME]',[WINDOW - OPTIONAL])",
        description: 'Returns the value from the querystring.',
        childNodes: [],
      },
      {
        nodeId: '61',
        label: 'If Then Else',
        usage: '({|base_qty|v_complaint-v_ss_case_part_lot.base_qty|} >= 500 ? "High" : "Low")',
        value: '([condition] ? [thenBlock] : [elseBlock])',
        description: 'Returns one of two objects, depending on the evaluation of an expression.',
        childNodes: [],
      },
      {
        nodeId: '62',
        label: 'Is Equal',
        usage: "ss.isEqual({|grc_status|v_complaint.grc_status|},'open')",
        value: "ss.isEqual('[LEFT_VALUE]','[RIGHT_VALUE]')",
        description:
          'Returns true if the first argument is equal to the second argument, otherwise returns false. This is required if checking if two dates are equal.',
        childNodes: [],
      },
      {
        nodeId: '63',
        label: 'Record Number',
        usage: 'ss.getRecordNumber()',
        value: 'ss.getRecordNumber()',
        description: 'Returns the record number.',
        childNodes: [],
      },
      {
        nodeId: '64',
        label: 'Select Element By ID Prefix',
        usage: "ss.selectElementByIDPrefix('V_COMPLAINT_ZOOM')",
        value: "ss.selectElementByIDPrefix('[CLIENT_ID]')",
        description: 'Selects elements on the page where ids starts with the client id prefix.',
        childNodes: [],
      },
      {
        nodeId: '65',
        label: 'Select Element By ID',
        usage: "ss.selectElementByID('V_COMPLAINT_FIRST_NAME_1')",
        value: "ss.selectElementByID('[CLIENT_ID]')",
        description: 'Selects an element on the page using its client id.',
        childNodes: [],
      },
      {
        nodeId: '66',
        label: 'Starts With',
        usage:
          "ss.startsWith({|description|v_complaint.complaint_closure_comment|}, 'This complaint')",
        value: "ss.startsWith([DATAMEMBER_COLUMN or 'text'], [DATAMEMBER_COLUMN or 'text'])",
        description:
          'Returns true if the first argument string starts with the second argument string; otherwise returns false.',
        childNodes: [],
      },
      {
        nodeId: '67',
        label: 'Step Id',
        usage: 'ss.stepId()',
        value: 'ss.stepId()',
        description: 'Returns the workflow step id.',
        childNodes: [],
      },
      {
        nodeId: '68',
        label: 'Step Name',
        usage: 'ss.stepName()',
        value: 'ss.stepName()',
        description: 'Returns the workflow step name.',
        childNodes: [],
      },
      {
        nodeId: '69',
        label: 'Translate Text',
        usage: "ss.getFormTranslation('SaveAllDocuments')",
        value: "ss.getFormTranslation('[TRANSLATION_KEY]')",
        description: 'Gets a translation from the server.',
        childNodes: [],
      },
      {
        nodeId: '70',
        label: 'Translated Step Name',
        usage: 'ss.translatedStepName()',
        value: 'ss.translatedStepName()',
        description: 'Returns translated workflow step name.',
        childNodes: [],
      },
      {
        nodeId: '71',
        label: 'Workflow Id',
        usage: 'ss.workflowId()',
        value: 'ss.workflowId()',
        description: 'Returns the workflow id.',
        childNodes: [],
      },
      {
        nodeId: '72',
        label: 'Workflow Key',
        usage: 'ss.workflowKey()',
        value: 'ss.workflowKey()',
        description: 'Returns the workflow key.',
        childNodes: [],
      },
      {
        nodeId: '73',
        label: 'Is Mobile Device',
        usage: 'ss.isMobileDevice()',
        value: 'ss.isMobileDevice()',
        description: 'Returns "true" if users screen width is below 480px.',
        childNodes: [],
      },
    ],
  },
  {
    nodeId: '74',
    label: 'Advance Functions',
    usage: '',
    value: '',
    description: '',
    childNodes: [
      {
        nodeId: '75',
        label: 'Build Grid Title',
        usage:
          "ss.buildGridTitle(ss.getFormTranslation('GRID_TITLE'), {|complaint|v_complaint|}, 'v_complaint-v_ss_case_part_lot', 'dispositionedpartlot')",
        value:
          "ss.buildGridTitle(ss.getFormTranslation('[TRANSLATION_KEY]'), [PARENT_DATAMEMBER], '[DATAMEMBER_NAME]', '[CONTROL_ID]')",
        description: 'Build grid title.',
        childNodes: [],
      },
      {
        nodeId: '76',
        label: 'Build Row Title',
        usage:
          "ss.buildRowTitle(ss.getFormTranslation('ROW_TITLE'), {|complaint|v_complaint|}, 'v_complaint-v_ss_case_part_lot', data, 'dispositionedpartlot')",
        value:
          "ss.buildRowTitle(ss.getFormTranslation('[TRANSLATION_KEY]'), [PARENT_DATAMEMBER], '[DATAMEMBER_NAME]', data, '[CONTROL_ID]')",
        description: 'Build row title.',
        childNodes: [],
      },
      {
        nodeId: '77',
        label: 'Column Value Not Unique',
        usage:
          "ss.columnValueNotUnique({|complaint|v_complaint|}, 'country_of_origin','newcomplaints')",
        value: "ss.columnValueNotUnique([DATAMEMBER], '[COLUMN_NAME]', '[CONTROL_ID - OPTIONAL]')",
        description: 'Returns true if column value is not unique.',
        childNodes: [],
      },
      {
        nodeId: '78',
        label: 'Convert To Double-Pipe Delimited String',
        usage:
          "ss.convertArrayToDoublePipeDelimitedString({|complaint|v_complaint|}, 'v_complaint-v_ss_case_part_lot', 'prt_complaint_qty', 'dispositionedpartlot')",
        value:
          "ss.convertArrayToDoublePipeDelimitedString([PARENT_DATAMEMBER], '[DATAMEMBER_NAME]', '[COLUMN_NAME]', '[CONTROL_ID - OPTIONAL]')",
        description:
          "Used for building the values in the correct format for the IN operator of filter conditions. Returns a string built from the values, each value seperated by '||'",
        childNodes: [],
      },
      {
        nodeId: '79',
        label: 'Get Current Row Value',
        usage: "ss.getCurrentRowValue(data, 'country_of_origin','N/A')",
        value: "ss.getCurrentRowValue(data, '[COLUMN_NAME]','[NULL_VALUE]')",
        description: 'Returns a column value from the current row being evaluated.',
        childNodes: [],
      },
      {
        nodeId: '80',
        label: 'Get Entity DataStore',
        usage: 'ss.getEntityDataStore()',
        value: 'ss.getEntityDataStore()',
        description: 'Returns a entity data store.',
        childNodes: [],
      },
      {
        nodeId: '81',
        label: 'Get Support Data',
        usage: "ss.getSupportData({|complaint|v_complaint|}, 'actorcountry', 'phy_country=usa')",
        value: "ss.getSupportData([DATAMEMBER], '[DATA_SOURCE_NAME]', '[FILTER - OPTIONAL]')",
        description: 'Returns data from smartsolve datasource.',
        childNodes: [],
      },
      {
        nodeId: '82',
        label: 'Get Task/Phase Status',
        usage:
          "ss.getStatus('workflow_name','start_phase_name','start_step_name','end_phase_name','end_step_name')",
        value:
          "ss.getStatus('[WORKFLOWNAME]', '[STARTPHASENAME]', '[STARTSTEPNAME]', '[ENDPHASENAME]', '[ENDSTEPNAME]')",
        description:
          'Returns a status(taskDisplayStatusCompleted,taskDisplayStatusStarted,taskDisplayStatusNA,taskDisplayStatusTBD) for Task or Phase.',
        childNodes: [],
      },
      {
        nodeId: '83',
        label: 'Max',
        usage:
          "ss.max({|complaint|v_complaint|}, 'v_complaint-v_ss_case_part_lot', 'prt_complaint_qty', 'dispositionedpartlot')",
        value:
          "ss.max([PARENT_DATAMEMBER], '[DATAMEMBER_NAME]', '[COLUMN_NAME]', '[CONTROL_ID - OPTIONAL]')",
        description:
          'Returns the maximum value from all non-null values of the specified expression.',
        childNodes: [],
      },
      {
        nodeId: '84',
        label: 'Max With Filter',
        usage:
          "ss.maxWithFilter({|Complaint|V_COMPLAINT|}, 'V_COMPLAINT-V_SS_CASE_PART_LOT', 'PRT_COMPLAINT_QTY', '[{''OpenGroup'':''false'',''LeftType'':''column'',''LeftValue'':''V_COMPLAINT-V_SS_CASE_PART_LOT.MYSERIALNUMBER'',''Operator'':''LT'',''RightType'':''number'',''RightValue'':''33'',''CloseGroup'':''false'',''RelationalOperator'':''AND''},{''OpenGroup'':''false'',''LeftType'':''column'',''LeftValue'':''V_COMPLAINT-V_SS_CASE_PART_LOT.MYSERIALNUMBER'',''Operator'':''LT'',''RightType'':''number'',''RightValue'':''33'',''CloseGroup'':''false'',''RelationalOperator'':''AND''}]')",
        value:
          "ss.maxWithFilter([PARENT_DATAMEMBER], '[DATAMEMBER_NAME]', '[COLUMN_NAME]', '[CONDITION]')",
        description:
          'Returns the maximum of the values of the specified expression based on the filter condition.',
        childNodes: [],
      },
      {
        nodeId: '85',
        label: 'Min',
        usage:
          "ss.min({|complaint|v_complaint|}, 'v_complaint-v_ss_case_part_lot', 'prt_complaint_qty', 'dispositionedpartlot')",
        value:
          "ss.min([PARENT_DATAMEMBER], '[DATAMEMBER_NAME]', '[COLUMN_NAME]', '[CONTROL_ID - OPTIONAL]')",
        description:
          'Returns the minimum value from all non-null values of the specified expression.',
        childNodes: [],
      },
      {
        nodeId: '86',
        label: 'Minimum Value',
        usage:
          "ss.minimumValue({|complaint|v_complaint|}, 'v_complaint-v_ss_case_part_lot', 'prt_complaint_qty', 'dispositionedpartlot')",
        value:
          "ss.minimumValue([PARENT_DATAMEMBER], '[DATAMEMBER_NAME]', '[COLUMN_NAME]', '[CONTROL_ID - OPTIONAL]')",
        description:
          'Returns the minimum value from all non-null values of the specified expression.',
        childNodes: [],
      },
      {
        nodeId: '87',
        label: 'Min With Filter',
        usage:
          "ss.minWithFilter({|Complaint|V_COMPLAINT|}, 'V_COMPLAINT-V_SS_CASE_PART_LOT', 'PRT_COMPLAINT_QTY', '[{''OpenGroup'':''false'',''LeftType'':''column'',''LeftValue'':''V_COMPLAINT-V_SS_CASE_PART_LOT.MYSERIALNUMBER'',''Operator'':''LT'',''RightType'':''number'',''RightValue'':''33'',''CloseGroup'':''false'',''RelationalOperator'':''AND''},{''OpenGroup'':''false'',''LeftType'':''column'',''LeftValue'':''V_COMPLAINT-V_SS_CASE_PART_LOT.MYSERIALNUMBER'',''Operator'':''LT'',''RightType'':''number'',''RightValue'':''33'',''CloseGroup'':''false'',''RelationalOperator'':''AND''}]')",
        value:
          "ss.minWithFilter([PARENT_DATAMEMBER], '[DATAMEMBER_NAME]', '[COLUMN_NAME]', '[CONDITION]')",
        description:
          'Returns the minimum of the values of the specified expression based on the filter condition.',
        childNodes: [],
      },
      {
        nodeId: '88',
        label: 'Previous Row Value',
        usage: "ss.previousRowValue({|complaint|v_complaint|}, 'is_complaint')",
        value: "ss.previousRowValue([DATAMEMBER], '[COLUMN_NAME]', '[CONTROL_ID - OPTIONAL]')",
        description: 'Returns the value from the previous row.',
        childNodes: [],
      },
      {
        nodeId: '89',
        label: 'Row Count',
        usage:
          "ss.rowCount({|complaint|v_complaint|}, 'v_complaint-v_ss_case_part_lot', 'dispositionedpartlot')",
        value: "ss.rowCount([PARENT_DATAMEMBER], '[DATAMEMBER_NAME]', '[CONTROL_ID - OPTIONAL]')",
        description: 'Returns a count of rows within the specified scope.',
        childNodes: [],
      },
      {
        nodeId: '90',
        label: 'Row Count With Filter',
        usage:
          "ss.rowCountWithFilter({|Complaint|V_COMPLAINT|}, 'V_COMPLAINT-V_SS_CASE_PART_LOT', '[{''OpenGroup'':''false'',''LeftType'':''column'',''LeftValue'':''V_COMPLAINT-V_SS_CASE_PART_LOT.MYSERIALNUMBER'',''Operator'':''LT'',''RightType'':''number'',''RightValue'':''33'',''CloseGroup'':''false'',''RelationalOperator'':''AND''},{''OpenGroup'':''false'',''LeftType'':''column'',''LeftValue'':''V_COMPLAINT-V_SS_CASE_PART_LOT.MYSERIALNUMBER'',''Operator'':''LT'',''RightType'':''number'',''RightValue'':''33'',''CloseGroup'':''false'',''RelationalOperator'':''AND''}]')",
        value: "ss.rowCountWithFilter([PARENT_DATAMEMBER], '[DATAMEMBER_NAME]', '[CONDITION]')",
        description: 'Returns a count of rows based on the filter condition',
        childNodes: [],
      },
      {
        nodeId: '91',
        label: 'Row Index',
        usage: "ss.rowIndex({|complaint|v_complaint|},'newcomplaints')",
        value: "ss.rowIndex([DATAMEMBER], '[CONTROL_ID - OPTIONAL]')",
        description: 'Returns the index of a row in a repeating control.',
        childNodes: [],
      },
      {
        nodeId: '92',
        label: 'Sum',
        usage:
          "ss.sum({|complaint|v_complaint|}, 'v_complaint-v_ss_case_part_lot', 'prt_complaint_qty', 'dispositionedpartlot')",
        value:
          "ss.sum([PARENT_DATAMEMBER], '[DATAMEMBER_NAME]', '[COLUMN_NAME]', '[CONTROL_ID - OPTIONAL]')",
        description:
          'Returns a sum of the values of the specified expression for numeric data type.',
        childNodes: [],
      },
      {
        nodeId: '93',
        label: 'Sum With Filter',
        usage:
          "ss.sumWithFilter({|Complaint|V_COMPLAINT|}, 'V_COMPLAINT-V_SS_CASE_PART_LOT', 'PRT_COMPLAINT_QTY', '[{''OpenGroup'':''false'',''LeftType'':''column'',''LeftValue'':''V_COMPLAINT-V_SS_CASE_PART_LOT.MYSERIALNUMBER'',''Operator'':''LT'',''RightType'':''number'',''RightValue'':''33'',''CloseGroup'':''false'',''RelationalOperator'':''AND''},{''OpenGroup'':''false'',''LeftType'':''column'',''LeftValue'':''V_COMPLAINT-V_SS_CASE_PART_LOT.MYSERIALNUMBER'',''Operator'':''LT'',''RightType'':''number'',''RightValue'':''33'',''CloseGroup'':''false'',''RelationalOperator'':''AND''}]')",
        value:
          "ss.sumWithFilter({|Complaint|V_COMPLAINT|}, 'V_COMPLAINT-V_SS_CASE_PART_LOT', 'PRT_COMPLAINT_QTY', '[{''OpenGroup'':''false'',''LeftType'':''column'',''LeftValue'':''V_COMPLAINT-V_SS_CASE_PART_LOT.MYSERIALNUMBER'',''Operator'':''LT'',''RightType'':''number'',''RightValue'':''33'',''CloseGroup'':''false'',''RelationalOperator'':''AND''},{''OpenGroup'':''false'',''LeftType'':''column'',''LeftValue'':''V_COMPLAINT-V_SS_CASE_PART_LOT.MYSERIALNUMBER'',''Operator'':''LT'',''RightType'':''number'',''RightValue'':''33'',''CloseGroup'':''false'',''RelationalOperator'':''AND''}]')",
        description:
          'Returns a sum of the values of the specified expression based on the filter condition for numeric data type.',
        childNodes: [],
      },
      {
        nodeId: '94',
        label: 'Evaluate Dynamic Formula',
        usage: 'ss.evaluateDynamicFormula({#Title|V_SDC_SMART_DOCUMENT.DOC_TITLE#})',
        value: 'ss.evaluateDynamicFormula({#Title|V_SDC_SMART_DOCUMENT.DOC_TITLE#})',
        description:
          'Returns the results of evaluation of fields/columns present in a formula. In the above sample, if on change of field “UDF1”, “Title” is updated with a formula with value of "{#UDF 1|V_SDC_SMART_DOCUMENT.DOC_UDF_STRING_1#} - Demo for new Formula" then the end result of evaluation seen in the sample will actually show the value entered for the UDF1 field. If the value entered for UDF1 is “My dynamic value”, then the end result will yield “My dynamic value - Demo for new Formula”.',
        childNodes: [],
      },
    ],
  },

  {
    nodeId: '95',
    label: 'Module Functions',
    usage: '',
    value: '',
    description: '',
    childNodes: [
      {
        nodeId: '96',
        label: 'IsModuleInstalled',
        usage: "ss.isModuleInstalled('ModuleName')",
        value: "ss.isModuleInstalled('ModuleName')",
        description:
          'Returns True if the specified module is installed. Otherwise it returns False.',
        childNodes: [],
      },
      {
        nodeId: '97',
        label: 'IsModuleLicensed',
        usage: "ss.isModuleLicensed('ModuleName')",
        value: "ss.isModuleLicensed('ModuleName')",
        description:
          'Returns True if the specified module is licensed. Otherwise it returns False.',
        childNodes: [],
      },
    ],
  },

  {
    nodeId: '98',
    label: 'Application Functions',
    usage: '',
    value: '',
    description: '',
    childNodes: [
      {
        nodeId: '99',
        label: 'GetApplicationSetting',
        usage: "ss.getApplicationSetting('SettingKey')",
        value: "ss.getApplicationSetting('SettingKey')",
        description:
          'Returns the application setting of the given key. Key should be in the format Solution/Name as described in Application Settings.',
        childNodes: [],
      },
      {
        nodeId: '100',
        label: 'ParentOrgUnitType',
        usage: "ss.parentOrgUnitType('OrganizationUnitType')",
        value: "ss.parentOrgUnitType('OrganizationUnitType')",
        description:
          "Returns the parent Organization Unit Type for a given Organization Unit Type. If the parent doesn't exist, then  the return value is 'N/A'",
        childNodes: [],
      },
      {
        nodeId: '101',
        label: 'ParentOrgUnitLevel',
        usage: "ss.parentOrgUnitLevel('OrganizationUnitType')",
        value: "ss.parentOrgUnitLevel('OrganizationUnitType')",
        description:
          "Returns the level of parent Organization Unit for a given Organization Unit Type. Example includes '1', '5' or '6' for level 1, level 5 and level 6 respectively. If the parent doesn't exist, then the return value is 'N/A'",
        childNodes: [],
      },
    ],
  },
];
